import { StoryEntry } from "@/features/story/components/StoryEntry";

export function HomePage() {
  return <StoryEntry />;
}
